import { render, staticRenderFns } from "./UpgradeListModal.vue?vue&type=template&id=ecdc66e6&"
import script from "./UpgradeListModal.vue?vue&type=script&lang=js&"
export * from "./UpgradeListModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports